<div
  class="section-card"
  [class.section-card--compact]="variant === 'compact'"
  [style.width]="width"
  [style.height]="height"
>
  <div class="section-card__header">
    <!-- Ícono OPCIONAL -->
    <div
      class="section-card__icon"
      *ngIf="icon"
      [style.background-color]="hasBackgroundIcon ? iconBgColor : 'transparent'"
    >
      <lucide-icon [img]="icon" [style.color]="iconColor" [size]="20"></lucide-icon>
    </div>

    <div class="section-card__titles">
      <div class="section-card__title-row">
        <section>
          <h3 class="section-card__title">{{ title }}</h3>
        </section>

        <span class="section-card__divider" *ngIf="divider"></span>

        <span class="section-card__badge" *ngIf="badge">{{ badge }}</span>
      </div>

      <p class="section-card__subtitle" *ngIf="subtitle">{{ subtitle }}</p>

      <p class="section-card__extra" *ngIf="extraText">{{ extraText }}</p>

      <div class="section-card__bottom-badges" *ngIf="bottomBadges.length > 0">
        <span
          class="section-card__bottom-badge"
          *ngFor="let b of bottomBadges"
          [style.color]="resolveBottomBadgeColor(b)"
          [style.background-color]="resolveBottomBadgeBg(b)"
        >
          {{ b.text }}
        </span>
      </div>
    </div>
  </div>
  <!-- 👇 Fila 5: Rayita separadora (DESPUÉS delheader) -->
  <span class="section-card__extra-divider" *ngIf="extraDivider"></span>

  <div class="section-card__body">
    <ng-content></ng-content>
  </div>

  <div class="section-card__footer" *ngIf="hasFooter">
    <ng-content select="[card-footer]"></ng-content>
  </div>
</div>
